import { useCallback } from 'react'

import { useArtifactCanvas } from '@/components/artifact/artifact-canvas-context'

import { canvasPagePath, findCanvas } from './slots'
import type { PluginCanvasEntity } from './types'

/** Query param that opens a page-targeted canvas on load: `?canvas=<id>`. */
export const PLUGIN_CANVAS_PARAM = 'canvas'

export type OpenPluginCanvasOptions = {
  params?: Record<string, string>
  entity?: PluginCanvasEntity | null
  data?: unknown
}

/** Open a registered pack canvas by id. Returns false when no canvas has that id. */
export function useOpenPluginCanvas(): (id: string, options?: OpenPluginCanvasOptions) => boolean {
  const { openCanvas, closeCanvas } = useArtifactCanvas()
  return useCallback(
    (id, options = {}) => {
      const manifest = findCanvas(id)
      if (!manifest) return false
      const params = options.params ?? {}
      const entity = options.entity ?? null
      const Render = manifest.render
      openCanvas({
        title: manifest.title,
        preventAutoFocus: true,
        surface: manifest.surface?.({ params, entity }) ?? undefined,
        content: (
          <Render
            key={`${id}:${entity?.kind ?? ''}:${entity?.id ?? ''}:${Date.now()}`}
            canvasId={id}
            mode="canvas"
            params={params}
            entity={entity}
            data={options.data}
            pagePath={canvasPagePath(manifest, params, entity)}
            close={closeCanvas}
          />
        ),
      })
      return true
    },
    [closeCanvas, openCanvas],
  )
}
